module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAQAAAASCAYAAAB8fn/4AAAANklEQVQoU2Nkz9qQzsjwv+U/IwMLI8P/Akb27PXvGRkYBBhA4D/DGywC6FrASpEAI2GBoWstAEFROVsWz6QUAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/theme2/column.png
// module id = UIPR
// module chunks = 68